import { h } from "preact";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { classNames } from "../helpers.js";
import { removeToastMessage } from "../store";
import Icon from "./Icon.jsx";

export default function Toasts() {
  const dispatch = useDispatch();
  const toasts = useSelector((state) => state.ui.toasts);

  function hideItem(toast) {
    dispatch(removeToastMessage(toast.id));
  }

  return (
    <TransitionGroup className="nio-toast-container">
      {toasts.map((toast) => (
        <CSSTransition
          key={toast.id}
          timeout={500}
          classNames="nio-toast-trans"
        >
          <div
            class={classNames(
              "nio-toast",
              toast.type === "info" && "nio-toast--info",
              toast.type === "success" && "nio-toast--success",
              toast.type === "error" && "nio-toast--error"
            )}
          >
            <span class="nio-toast__content">{toast.message}</span>
            <Icon class="nio-toast__closer" onClick={() => hideItem(toast)}>
              close
            </Icon>
          </div>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
}
